/* eslint-disable no-unused-vars */
import React, { useState, useEffect } from "react";
import { Delete } from "@material-ui/icons";
import { Button } from "react-bootstrap";
import RangeSlider from "./SliderComponent";

const MaterialOpacityInteraction = ({
  materialName,
  opacityValue,
  setMaterialConfig,
  applyOpacity,
  removeMaterial,
  updateConfig,
}) => {
  const [value, setValue] = useState(opacityValue);

  useEffect(() => {
    setValue(opacityValue);
  }, [opacityValue]);

  return (
    <div className="opacityInteraction">
      <div className="componentWrapper">
        <div className="materialHeader">
          <div className="title">{materialName}</div>
          <div className="actions">
            <Button
              onClick={() => {
                applyOpacity({
                  opacity: 1,
                  visible: true,
                });
                removeMaterial();
              }}
            >
              <Delete fontSize="small" />
            </Button>
          </div>
        </div>
        <div className="sliderWrapper">
          <RangeSlider
            onSliderChange={(sliderValue) => {
              setValue(sliderValue);
              applyOpacity({
                opacity: sliderValue,
                visible: sliderValue > 0,
                transparent: sliderValue > 0 && sliderValue < 1,
              });
            }}
            onAfterChange={(sliderValue) => {
              applyOpacity({
                opacity: sliderValue,
                visible: sliderValue > 0,
                transparent: sliderValue > 0 && sliderValue < 1,
              });
              updateConfig();
            }}
            value={value}
          />
        </div>
      </div>
    </div>
  );
};

export default MaterialOpacityInteraction;
